module.exports = __webpack_public_path__ + "static/media/NJ0151-53M_03.200a2d78.png";